import * as React from 'react';
import { Facet } from '@elastic/react-search-ui';
import { useClickOutside } from '../../helper';

export default function OpenSearchFacet(props) {
  const {field, label, show} = props;

  const [isOpen, setIsOpen] = React.useState(false);

  const rootEl = React.useRef(null);

  const handleClickOutside = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  useClickOutside(rootEl, handleClickOutside);

  const handleClick = () => {
    setIsOpen(prev => !prev);
  }

  const containerClass = `facet facet--dropdown ${isOpen ? 'facet--expanded' : ''}`;

  return (
    <div className={containerClass} ref={rootEl}>
      <button className='facet__button' onClick={handleClick}>
        {label}
      </button>
      <div className='facet__items'>
        <div className='facet__scroll'>
          <Facet field={field} show={show} label={label} filterType='any'/>
        </div>
      </div>
    </div>
  )
}
